import {
  Compass,
  Gamepad2,
  List,
  Users,
  type LucideIcon,
} from "lucide-react";
import styles from "./BottomNavigation.module.css";

export type NavigationTab = "games" | "discover" | "activity" | "friends";

interface NavigationItem {
  id: NavigationTab;
  label: string;
  icon: LucideIcon;
}

interface BottomNavigationProps {
  activeTab: NavigationTab;
  onTabChange: (tab: NavigationTab) => void;
}

const navigationItems: readonly NavigationItem[] = [
  { id: "games", label: "Spel", icon: Gamepad2 },
  { id: "discover", label: "Upptäck", icon: Compass },
  { id: "activity", label: "Aktivitet", icon: List },
  { id: "friends", label: "Vänner", icon: Users },
];

export function BottomNavigation({
  activeTab,
  onTabChange,
}: BottomNavigationProps) {
  return (
    <nav className={styles.navigation} aria-label="Huvudnavigering">
      {navigationItems.map((item) => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;

        return (
          <button
            className={styles.item}
            type="button"
            key={item.id}
            aria-current={isActive ? "page" : undefined}
            onClick={() => onTabChange(item.id)}
          >
            <span className={styles.iconWrap}>
              <Icon aria-hidden="true" />
            </span>
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
